import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
	field: {
		fontWeight: 'bold',
	},
}));
// Typography Component for field and value.
function FieldValTypography({ field, val }) {
	const classes = useStyles();
	return (
		<Typography variant="body1">
			<span className={classes.field}>{field}</span>: {val}
		</Typography>
	);
}
export default FieldValTypography;
